import type { Language } from '@/shared/entities/Language'

export class CancelMealReasonEntity {
  id?: number
  translations?: Array<{
    title?: string | null
    language?: Language
  }> | null
}
